// reach_ui/src/components/VastGPT/ChatHeader.js
import React from 'react'
import { IconButton } from '@material-ui/core'
import { Menu, Close } from '@material-ui/icons'

const ChatHeader = ({
  title,
  loadingResponse,
  selectedChatId,
  onOpenDrawer,
  onClose,
}) => (
  <div className="AiChatHeader">
    <IconButton onClick={onOpenDrawer}>
      <Menu />
    </IconButton>
    <div className="AiChatTitle">
      {loadingResponse === 'initial' && !selectedChatId ? 'Loading...' : title}
    </div>
    <IconButton onClick={onClose}>
      <Close />
    </IconButton>
  </div>
)

export default ChatHeader
